import { useState, useEffect } from 'react'
import { useDashboardOperationalStore } from 'Store/DashboardOperational'
import moment from 'moment'

const ViewModel = () => {
  const INITIAL_START_DATE = moment().tz('Asia/Bangkok').startOf('week').toDate()
  const INITIAL_END_DATE = moment().tz('Asia/Bangkok').endOf('week').toDate()

  const [startDate, setStartDate] = useState<Date>(INITIAL_START_DATE)
  const [endDate, setEndDate] = useState<Date>(INITIAL_END_DATE)
  const [dataType, setDataType] = useState<'month' | 'daily'>('month')
  const dataTypeOptions = [
    { label: 'รายเดือน', value: 'month' },
    { label: 'รายวัน', value: 'daily' },
  ]

  const {
    projectStats,
    projectPileStats,
    projectPilingProgress,
    getProjectStats,
    getProjectPileStats,
    getProjectPilingProgress,
  } = useDashboardOperationalStore(state => ({
    projectStats: state.projectStats,
    projectPileStats: state.projectPileStats,
    projectPilingProgress: state.projectPilingProgress,
    getProjectStats: state.getProjectStats,
    getProjectPileStats: state.getProjectPileStats,
    getProjectPilingProgress: state.getProjectPilingProgress,
    clearState: state.clearState,
  }))

  const statBoxes = [
    {
      img: '/media/icons/total-project.svg',
      number: projectStats?.totalProjects ?? 0,
      title: 'ทั้งหมด',
      percentage: 0,
    },
    {
      img: '/media/icons/total-completed.svg',
      number: projectStats?.completedProjects ?? 0,
      title: 'เสร็จสิ้น',
      percentage: 0,
    },
    {
      img: '/media/icons/total-canceled.svg',
      number: projectStats?.inProgressProjects ?? 0,
      title: 'กำลังดำเนินการ',
      percentage: 0,
    },
    {
      img: '/media/icons/total-in-progress.svg',
      number: projectStats?.pendingProjects ?? 0,
      title: 'รอเปิดงาน',
      percentage: 0,
    },
  ]

  const fetchData = async () => {
    getProjectStats()
    getProjectPileStats()
  }

  const fetchPilingProgress = async () => {
    const from = moment(startDate).format('YYYY-MM-DD')
    const to = moment(endDate).format('YYYY-MM-DD')
    getProjectPilingProgress(from, to)
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    fetchPilingProgress()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate])

  return { statBoxes, projectPileStats, projectPilingProgress }
}

export default ViewModel
